<template>
  <section class="news-list" id="id-news-list">
      <div class="toptip" v-if="pushNums" id="pushNumId"><a>已为您推荐{{pushNums}}条内容</a></div>
      <div class="toptip" v-else-if="parseInt(pushNums)<=0" id="pushNumId"><a>暂无更新，请稍候再试</a></div>
      <!-- <div class="toptip" v-if="top_tip_id" :id="top_tip_id"><a @click="refreshNews(nowNewsType);countTo2345('ttxw_tab_' + nowNewsType + '_topdjck');">您有未读新闻，<span>点击查看</span></a></div> -->
      <article v-for="(value, key) in newsData" class="news" :id="value['id'] != 0 ? 'id_' + value['id']: ''">
					<!-- AD -->
					<!-- <ad360 v-if="value.isAd" :data="value"></ad360> -->
          <!--createThreeImgType-->
          <div v-if="value['pic'] && value['pic'].length >= 3">
              <header class = "news-text">
                  <h3>
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" class = "news-link"  :title="value['title']">{{value['title']}}</a>
                  </h3>
              </header>
              <div class="pic pic3">
                  <div class="imgs">
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" :style="'background-image: url(' + value['pic'][0] + ')'"></a>
                  </div>&nbsp;
                  <div class="imgs">
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" :style="'background-image: url(' + value['pic'][1] + ')'"></a>
                  </div>&nbsp;
                  <div class="imgs">
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" :style="'background-image: url(' + value['pic'][2] + ')'"></a>
                  </div>&nbsp;
              </div>
              <footer class="info" v-if="value['isvideo'] === 1 || value['isrecom'] === 1 || value['hotnews'] === 1">
                    <label v-show="value['isvideo'] === 1" class="label label-green">视频</label>
                    <label v-show="value['isrecom'] === 1" class="label label-blue">推荐</label>
                    <label v-show="value['hotnews'] === 1" class="label label-red">热门</label>
                    <label v-show="value['is360Ads'] === 1" class="label label-gray">广告</label>
                    <p>{{value['source']}}</p>
              </footer>
              <footer class="info" v-else>
                  <time v-text="getTimeStr(value['pushdate'])"></time>
                  <p>{{value['source']}}</p>
              </footer>
          </div>

          <!---OneSmallImgType---->
          <div v-else-if="value['pic'] && value['pic'].length <= 2">
              <div class="img">
                  <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" :style="'background-image: url(' + value['pic'][0] + ')'"></a>
              </div>
              <header class="news-text">
                  <h3>
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" class="news-link" :title="value['topic']">{{value['title']}}</a>
                  </h3>
              </header>
              <footer class="info" v-if="value['isvideo'] === 1 || value['isrecom'] === 1 || value['hotnews'] === 1">
                  <label v-show="value['isvideo'] === 1" class="label label-green">视频</label>
                  <label v-show="value['isrecom'] === 1" class="label label-blue">推荐</label>
                  <label v-show="value['hotnews'] === 1" class="label label-red">热门</label>
                  <label v-show="value['is360Ads'] === 1" class="label label-gray">广告</label>
                  <p>{{value['source']}}</p>
              </footer>
              <footer class="info" v-else>
                  <time v-text="getTimeStr(value['pushdate'])"></time>
                  <p>{{value['source']}}</p>
              </footer>
          </div>
          <!-- <div v-else-if="value['isGameAds']===1">
              <div class="img">
                  <a :href="value['url']"  @onclick.prevent="openUrl(value['url'], value['uniquekey']);"  :style="'background-image: url(' + value['src'] + ')'"></a>
              </div>
              <header class="news-text">
                  <h3>
                      <a :href="value['url']"  @onclick.prevent="openUrl(value['url'], value['uniquekey']);" class="news-link" :title="value['topic']">{{value['topic']}}</a>
                  </h3>
              </header>
              <footer class="info">
                  <time>{{value['timeStr']}}</time>
              </footer>
          </div> -->
          <!-- <div v-if="value['pic'] && value['pic'].length <= 2">
              <header class = "news-text">
                  <h3>
                      <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])" class = "news-link"  :title="value['title']">{{value['title']}}</a>
                  </h3>
              </header>
              <div class = "pic pic1">
                  <div class = "imgs">
                  <a :href="value['url']"  @click.prevent="openUrl(value['url'], value['uniquekey'])"  :style = "'background-image: url(' + value['pic'][0] + ')'"></a>
                  </div>
              </div>
              <footer class="info" v-if="value['isvideo'] === 1 || value['isrecom'] === 1 || value['hotnews'] === 1">
                  <label v-show="value['isvideo'] === 1" class="label label-green">视频</label>
                  <label v-show="value['isrecom'] === 1" class="label label-blue">推荐</label>
                  <label v-show="value['hotnews'] === 1" class="label label-red">热门</label>
                  <label v-show="value['is360Ads'] === 1" class="label label-gray">广告</label>
                  <p>{{value['source']}}</p>
              </footer>
              <footer class="info" v-else>
                  <time v-text="getTimeStr(value['pushdate'])"></time>
                  <p>{{value['source']}}</p>
              </footer>
          </div> -->
          <!-- <div v-else-if="value['isvideo']===1">
              <div class="img">
                  <a :href="value['url']"  @onclick.prevent="openUrl(value['url'], value['uniquekey'])"  class="news-link" :style="'background-image: url(' + value['miniimg'][0]['src'] + ')'">
                      <span class="play_icon"></span>
                  </a>
              </div>
              <header class="news-text">
                  <h3>
                      <a :href="value['url']"  @onclick.prevent="openUrl(value['url'], value['uniquekey'])"  class="news-link" :title="value['topic']">{{value['topic']}}</a>
                  </h3>
              </header>
              <footer class="info">
                  <label class="label label-green">视频</label>
                  <p>{{value['source']}}</p>
              </footer>
          </div> -->
          <div v-else-if="!value['pic'] || value['pic'].length === 0">
              <header class="news-text">
                  <h3>
                      <a :href="value['url']"  @onclick.prevent="openUrl(value['url'], value['uniquekey'])"  class="news-link"  :title="value['title']">{{value['title']}}</a>
                  </h3>
              </header>
              <footer class="info" v-if="value['isvideo'] === 1 || value['isrecom'] === 1 || value['hotnews'] === 1">
                  <label v-show="value['isvideo'] === 1" class="label label-green">视频</label>
                  <label v-show="value['isrecom'] === 1" class="label label-blue">推荐</label>
                  <label v-show="value['hotnews'] === 1" class="label label-red">热门</label>
                  <label v-show="value['is360Ads'] === 1" class="label label-gray">广告</label>
                  <p>{{value['source']}}</p>
              </footer>
              <footer class="info" v-else>
                  <time v-text="getTimeStr(value['pushdate'])"></time>
                  <p>{{value['source']}}</p>
              </footer>
          </div>
      </article>
      <!-- <div class="news-tips" v-if="id_foottip" :id="id_foottip"><p>查看更多新闻，请<a class="refresh_inline" href="#" ondragstart="return false" @click="refreshNews(nowNewsType);countTo2345('ttxw_tab_' + newsType + '_moref5');">点击刷新</a></p></div> -->
      <div class="news-tips" v-if="id_foottip" :id="id_foottip"><p>已经到底了</p></div>
  </section>
</template>

<script>
import df from '../api/dfNewsData'
const createLayer = require('../api/layer.js');
import filter from '../api/filter.js';
import { getAdData } from '../api/ad360'
import Ad360 from './Ad360'
const MILLISECONDS_IN_A_SECOND = 1000
const ONE_MINUTE = 60
const ONE_HOUR = 3600
const ONE_DAY = 86400

export default {
  name: 'NewsList',
	components: {
		Ad360,
	},
  data () {
    return {
        'nowNewsType' : 'recommend',
        'serverTime' : 1535009062,
        'topTipInterval' : 120000,// 顶部提示刷新间隔，单位毫秒（ms）
        'newsData' : [],
        'top_tip_id' : false,
        'id_foottip' : false,
        'startTime' : true,// 开始浏览的时间戳（ms）
        'beforeScrollTop' : $('#id-news-list').scrollTop(),// 初始化滚动条位置
        'remoteCheckTime' : 3000, // romoteCheckTIme后检测服务器异常 （ms）
        'remoteServerOk' : true,// 东方头条服务器是否正常连接
        'tabActiveTime' : {    // 记录标签更新时间
            recommend: 0,
            entertainment: 0,
            society: 0,
            junshi: 0
        },
        'lastUrlParam' : {},
        'arrNewsFilterRules' : null,
        'flushMaxNums' : 100, // 如果新增新闻数超过这个条数，则清空新闻列表
        'pushNums' : false, //显示推荐条数
        'showNumsTipTime' : 2000, // 更新条数提示，显示时长，单位毫秒（ms）
        'maxNewsLength'  : 300,// 每个页面中最多显示的条数,
        'tabUpdateDataTime': 1800000, // 点击标签检查刷新时间 (ms) 30min
				'flushInterval'  : 1800000, // 全量刷新的时间间隔，单位毫秒 （ms）
				pageInfo: {
					recommend: 1,
					entertainment: 1,
					society: 1
				}
    }
  },
  created : function () {
    this.pipe.$on('listen', (rec) => {
        var formula = '', args = [];
        if (rec instanceof Object)
        {
            $.each(rec, function(ind, val){
                if (ind == 'func')
                {
                    formula += val;
                }
                else
                {
                    args.push(val)
                }
            })
        }
        else
        {
            formula = rec;
        }

        this[formula](...args);
    });

    this.startTime = (new Date()).getTime();
  },
  mounted : function(){
    this.renderNews();  //初始化新闻流推荐页
    window.addEventListener('message', (e) => {
      if(e.data === 'refresh') {
          this.refreshNews();
      } else if (e.data === 'layer') {
          var times = 0;
          var layer = setInterval(() => {
              console.log(sessionStorage.getItem('showLayer'));
              if (sessionStorage.getItem('showLayer'))
              {
                  clearInterval(layer);
                  return;
              }
              times++;
              if (sessionStorage.getItem('firstNewsId'))
              {
                  var idStr = sessionStorage.getItem('firstNewsId');
                  sessionStorage.removeItem('firstNewsId');
                  createLayer('#' + idStr, '点击阅读，即可获得<span style="color: #ffcc00">金币</span>', ['0px', '13px', '0px', '5px'], ['0px', '-23px']);
                  sessionStorage.setItem('showLayer', 1);
                  clearInterval(layer);
              }
              if (layer && times >= 10)
              {
                  clearInterval(layer);
              }
          }, 500);
      }
    } , false);
  },
  methods : {
    clearHtml (){
        $('#id-news-list').html('');
    },
    prepareCommonData () {// 准备公用数据
        if (!this.getNewsData('uuid'))
        {
            this.setNewsData('uuid', this.getUUIDFromBro());// 设置uid
        }

        if (!this.getNewsData('lastFlushTime_' + this.nowNewsType))
        {
            var localTime = Date.parse(new Date());
            this.setNewsData('lastFlushTime_' + this.nowNewsType, localTime);// 设置第一次全部刷新的时间，采用本地时间
        }
    },
    getUUIDFromBro() {
        var baseData = chrome.ntp2345.getUserMachineInfo();
        var uuidData = baseData.substr(baseData.indexOf('uuid='));
        var uuid = uuidData.substring(5, uuidData.indexOf('&'));

        return uuid;
    },
    //打开链接
    openUrl (url, uniqueKey) {
//        console.log(url, uniqueKey);
        window.parent.postMessage(url, '*');
        // if (uniqueKey.length === 32) {// 如果不是新闻点击
				// this.countToDFTT(uniqueKey);
				this.countTo2345('ttxw_tab_' + this.nowNewsType + '_newsclick');
				this.countTo2345('ttxw_newsclick_user');
        // } else {
        //     this.countTo2345('ttxw_adclick_' + newsId);
        // }
    },
    showTopTip (newsType) {// 显示顶部提示
        this.top_tip_id = false;
        if(this.getInfo(newsType, 'toptip')){
            //console.log('toptip:' + this.getInfo(newsType, 'toptip'));
            this.createTopTipHtml(newsType);
        }
    },
    createTopTipHtml (newsType) {   //直接显示顶部提示
        if (!this.onlineOk() || $('.news').length < 1) {
            //console.log('interval return');
            return ;
        }
        if (newsType == this.nowNewsType)
        {
            var id = 'id_tip_' + newsType;
            this.top_tip_id = id;
            this.setInfo(newsType, 'toptip', 1);
            //console.log('top_tup_id:' + this.top_tip_id);
        }
    },
    delTopTipHtml () {// 删除顶部提示刷新
        var id = 'id_tip_' + this.nowNewsType;
        if($('#' + id).length > 0){
            this.setInfo(this.nowNewsType, 'toptip', 0);
            this.top_tip_id = false;
        }
    },
		showFootTip (newsType) {// 显示底部提示
        if(this.getInfo(newsType, 'foottip')){
            $('#id_foottip_' + newsType).length === 0 && this.createFootTipHtml(newsType);
        }
    },
    createFootTipHtml (newsType) {// 创建底部提示刷新
        var id = 'id_foottip_' + newsType;
        if($('#'+id).length === 0){
            this.id_foottip = id;
            this.setInfo(newsType, 'foottip', 1);
            $('#'+id).find('a').click(() => {
                if (this.onlineOk())
                {
                    this.delFootTipHtml();
                }
            });
        } else {
          $('#'+id).show();
        }
    },
    delFootTipHtml () {// 删除底部提示刷新
				var id = 'id_foottip_' + this.nowNewsType;
				// console.log('this.id_foottip', this.id_foottip)
        if($('#' + id).length > 0){
          this.setInfo(this.nowNewsType, 'foottip', 0);
          this.id_foottip = false;
        }
    },
    getInfo (type, key) {// 获取sessionStorage信息
				var infoKey = type + '_info';
				var infoVal = JSON.parse(this.getNewsData(infoKey));
        var returnInfo = (infoVal !== null && infoVal[key]) ? infoVal[key] : '';
        return returnInfo;
    },
    setInfo (type, key, value) {// 设置sessionStorage info信息
        var infoKey = type + '_info';
        var infoArr =  JSON.parse(this.getNewsData(infoKey));
        if ( infoArr === null ){infoArr = {};}

        if (key === 'idx_up') {
            infoArr[key] = infoArr[key] ? infoArr[key] + value : value;
        } else if (key === 'idx_down') {
            infoArr[key] = infoArr[key] ? infoArr[key] - value : '-' + value;
        } else {
            infoArr[key] = value;
        }

        this.setNewsData(infoKey, JSON.stringify(infoArr));
    },
    setNewsData (key, data) {// 写入数据
        sessionStorage.setItem(key, data);
    },
    getNewsData (key) {// 读取数据
        return sessionStorage.getItem(key);
    },
    showWatchedTip () {// 显示已观看位置
				var newsId = this.getInfo(this.nowNewsType, 'watched_loc');
        if(newsId){
            //console.log($('#'+newsId));
            $('#'+newsId).before(this.getWatchedHtml());
            $('.refresh_inline').click(() => {
                this.refreshNews();
                this.countTo2345('ttxw_tab_' + this.nowNewsType + '_heref5');
            });
            //console.log($($('.news-tips')[0]).prev());
            if($($('.news-tips')[0]).prev().attr('class') !== 'news'){
                //console.log('delWatch');
                this.delWatchedHtml();
            }
        }
    },
    getWatchedHtml () {// 获取刷新时的分割线
        this.delWatchedHtml();
        return '<div class="news-tips"><p>刚刚看到这里，<a class="refresh_inline" href="#" ondragstart="return false">点击刷新</a></p></div>';
    },
    delWatchedHtml () {
        if($('.news-tips').length > 0){
          $('.news-tips').remove();
        }
    },
    //检测有网
    onlineOk() {
        return navigator.onLine;
    },
    updateNewsType (newsType){  //触发更新当前新闻类型
       this.pipe.$emit('getNewsType');
    },
    getNewsType (newsType){ //更新当前新闻类型
        this.nowNewsType = newsType;
		},
		getTimeStr(timeStamp, now) {
			const time = ((now || Date.now()) - new Date(timeStamp).getTime()) / MILLISECONDS_IN_A_SECOND
			if (time >= ONE_DAY) {
				return `${Math.floor(time / ONE_DAY)}天前`
			} else if (time >= ONE_HOUR) {
				return `${Math.floor(time / ONE_HOUR)}小时前`
			} else if (time >= ONE_MINUTE) {
				return `${Math.floor(time / ONE_MINUTE)}分钟前`
			} else {
				return '刚刚'
			}
		},
    // getTimeStr (newsDate){  //获取当前时间距新闻更新时间的时间间隔字符串
    //     var timeStr = '';
    //     var serverDate = this.serverTime;
    //     var newsTime = new Date(1000 * newsDate);
    //     var timeDiff = serverDate - newsDate;
    //     var todayZero = Date.parse(new Date((new Date(1000 * serverDate)).toJSON().substr(0,10)+' 00:00')) / 1000;// 今天凌晨00:00时间戳
    //     var todayZeroTimeDiff = newsDate - todayZero;// 新闻时间和今天凌晨00:00的时间差
    //     if(timeDiff < 3600) {
    //         var minite = Math.ceil(timeDiff/60) > 0 ? Math.ceil(timeDiff/60) : Math.ceil( Math.random()*10 );
    //         timeStr = minite > 59 ? '59分钟前' : minite + '分钟前';
    //     } else if (todayZeroTimeDiff > 0 && todayZeroTimeDiff <= 86400) {
    //         timeStr = Math.floor(timeDiff /  3600 ) + '小时前';
    //     } else if (todayZeroTimeDiff <= 0 && todayZeroTimeDiff > -86400) {
    //         timeStr = '昨天 ' + (newsTime.getHours() < 10 ? '0' + newsTime.getHours() : newsTime.getHours()) + ':' + (newsTime.getMinutes() < 10 ? '0' + newsTime.getMinutes() : newsTime.getMinutes());
    //     } else if (todayZeroTimeDiff <= -86400) {
    //         timeStr = newsTime.getFullYear() +
    //             '-' + (newsTime.getMonth() < 9 ? '0' + (newsTime.getMonth() + 1) : newsTime.getMonth() + 1) +
    //             '-' + (newsTime.getDate() < 10 ? '0' + newsTime.getDate() : newsTime.getDate()) +
    //             ' ' + (newsTime.getHours() < 10 ? '0' + newsTime.getHours() : newsTime.getHours()) +
    //             ':' + (newsTime.getMinutes() < 10 ? '0' + newsTime.getMinutes() : newsTime.getMinutes());
    //     }

    //     return timeStr;
    // },
    renderNews (){  //初始化加载新闻
        this.prepareCommonData();   //准备公用数据
        this.initTypeData();    //初始化当前类型新闻
        this.listenHeight();    // 检测高度变化
        this.monitorTopTip();   //定时提示刷新顶部提示
        this.listenScroll();    //监听滚动条位置
        this.recorderScroll();  //记录各类型下滚动条位置
        this.checkHaveData();   //检测是否成功加载到东方头条数据
        //this.initFilterNewsRules();     //初始化过滤规则
        this.countTo2345('ttxw_show');  //发送展现统计
    },

    listenHeight () { // 检测高度变化
        this.setHeight();
        let self = this;
        var $event = $(window).data('events');
        if (!($event && $event['resize']))
        {
            $(window).on('resize', function () {
                self.setHeight();
            });
        }
    },
    monitorTopTip () {  //定时提示刷新顶部提示
        if (this['timeoutProcess'])
        {
            this.top_tip_id = false;
            clearInterval(this['timeoutProcess']);
        }
        this['timeoutProcess'] = setInterval(() => {
            if ($('#cover-201809121042').length == 0 || ($('#cover-201809121042').length > 0 && !$('#cover-201809121042').is(':visible')))
            {
                this.createTopTipHtml(this.nowNewsType);
            }
        }, this.topTipInterval);//指定时间重新计时，每个tab单独提示
    },
    listenScroll : function () {
        var self = this;
        $('#id-news-list').on('scroll', function(){
            let viewH = $(this).height();// 可见高度
            let contentH  = $(this).get(0).scrollHeight;// 内容高度
            let scrollTop = $(this).scrollTop();// 滚动高度
            if(scrollTop - self.beforeScrollTop > 0 && contentH - viewH - scrollTop <= 20){  // 到达底部100px时,加载新内容  scrollTop/(contentH - viewH) >= 0.95
                self.lazyLoadNews();
            }
            self.beforeScrollTop = scrollTop;

            // 发送展示统计
//          newsCenter.adposArr.forEach(function(id, index){
//              var dom = document.getElementById(id);
//              if (self.isElementInViewport(dom)) {
//                  var ind = newsCenter.adposArr.indexOf(dom.getAttribute('id'));
//                  if (ind !== -1) {
//                      newsCenter.adposArr.splice(ind, 1);
//                      var bgtjArr = [dom.getAttribute('bgtj0'), dom.getAttribute('bgtj1')];
//                      newsCenter.send360Ads(bgtjArr);
//                  }
//              }
//          })
        });

    },
    recorderScroll () {
        let self = this;
        // 内容滚动记录滚动条位置
        var $events = $(".news-list").data("events");
        if(!($events && $events["scroll"])){
            $('.news-list').on('scroll', function () {
                var _index = self.nowNewsType;
                self.setNewsData("scrollTop_" + _index, $(this).scrollTop());
            });
        }
    },
    loadOkNotice (){
        if ($('.mask').is(':visible'))
        {
            return;
        }
        window.parent.postMessage('loading_ok', '*');
    },
    checkHaveData () {// 检测是否成功加载到东方头条数据
        setTimeout(() => {
            if( $('.news').length === 0 ) {
              this.remoteServerOk = false;
              $('.mask').show();
              $('.no-data').show();
              $('.J_step01').show();
              $('.J_step02').hide();
              this.countTo2345('ttxw_low_connect');
            }
        }, this.remoteCheckTime);
    },
    initTypeData(){
        // 初始化时间
        if ((!this.getNewsData(this.nowNewsType) || this.getNewsData(this.nowNewsType) === '[]') && this.remoteServerOk) {
            if(!this.onlineOk()){// 断网下什么都不做处理
                return ;
            }
            var postData = {
                type : this.nowNewsType,
                startkey : this.getInfo(this.nowNewsType, 'endkey') || '',
                newkey : this.getInfo(this.nowNewsType, 'newkey') || '',
                page : this.pageInfo[this.nowNewsType],
                idx : 0,
                uid : this.getNewsData('uuid')
            };
            this.lastUrlParam = this.deepCopy(df.postData);

            this.setAndShowData(postData, false, 'end');
        }
    },
    deepCopy (arry1){
      var arry2 = {};
      $.each(arry1, function(ind, item){
          arry2[ind] = item;
      });

      return arry2;
    },
    setAndShowData (postData, append, apdType) {// 基本数据初始化,append--是否追加(true 追加 false 重写),apdType追加在原数据前（'begin'）还是后（'end'）
        // 防止重复发送
      if(this.lastUrlParam['page'] != 1 && this.lastUrlParam['page'] === postData['page'] && this.lastUrlParam['type'] === postData.type ){
          return ;
      }
        //console.log('lasturl', this.lastUrlParam);
      // 更新标签更新时间
      this.tabActiveTime[this.nowNewsType] = new Date().getTime();
      //console.log(this.nowNewsType + "更新标签时间:", this.tabActiveTime[this.nowNewsType]);
			this.delFootTipHtml()
      df.setParm(postData);
      df.getNewsList((err, list) => {
          if (list)
          {
              var allData = this.filterByNewsRulers(list);
              // var allData = this.filterByNewsRulers(list);
              var dataLen = allData.length;
              if(dataLen > 0){
									//newsCenter.prepare360Ads(dataLen,allData,type,append,apdType);
									this.pageInfo[this.nowNewsType] ++
              } else {
								this.createFootTipHtml(this.nowNewsType);
							}
							// getAdData().then(res => {
							// 	console.log(res)
							// 	if (typeof res !== 'string') {
							// 		let i = 2
							// 		while(i < allData.length + 2) {
							// 			let ad = res.splice(0, 1)
							// 			if (ad && ad[0]) {
							// 				ad[0].isAd = true
							// 				allData.splice(i, 0, ad[0])
							// 			}
							// 			i += 3
							// 		}
							// 	}
							// 	console.log(allData)
							// 	this.dealSuccess(allData, append, apdType);

							// })
							this.dealSuccess(allData, append, apdType);

          }
          else if (err)
          {
              console.log('err:', err);
              this.remoteServerOk = false;
              $('.mask').show();
              $('.no-data').show();
              $('.J_step01').show();
              $('.J_step02').hide();
              this.countTo2345('ttxw_low_connect');
          }

      })
    },
    initFilterNewsRules() {
        df.getFilterRule({'no_cache': (+new Date()), 'callback' : 'callBack'}, (err, list) => {
            if (list && list.length>0)
            {
                var tmpObj = {};
                list.map(function(matchInfo) {
                    if (!tmpObj['match_type_' + matchInfo.match_type]) {
                        tmpObj['match_type_' + matchInfo.match_type] = ''
                    } else {
                        tmpObj['match_type_' + matchInfo.match_type] += '|'
                    }
                    tmpObj['match_type_' + matchInfo.match_type] += matchInfo.match_string
                });
                this.arrNewsFilterRules = tmpObj;
                tmpObj = undefined;
                //console.log('过滤规则:', this.arrNewsFilterRules);
            }
            else
            {
                console.log('filterRule ERR:', err);
            }
        });
    },
    getNewsRules() {
        if (this.arrNewsFilterRules) {
          return this.arrNewsFilterRules;
        } else {
          return {};
        }
    },
    filterByNewsRulers (newsList) {
        //var rules = this.getNewsRules();
        if (newsList.length > 0) {
            filter.filterWithPath(newsList, '(*).title');
        }
        return newsList;
    },
		dealSuccess (allData, append, apdType) {// 处理成功数据
        this.remoteServerOk && this.clearErrorHtml();
        this.serverTime = allData.ts;// 更新至服务器时间
        apdType !== 'end' && this.showPushNums(allData);// 显示推荐条数
        apdType !== 'end' && (allData = allData.reverse());
        if (append)
        {
            if (apdType == 'end')
            {
                // console.log('before concat', this.newsData);
                this.newsData = this.newsData.concat(allData);// 显示新数据
                // console.log('after concat', this.newsData);
            }
            else
            {
                // console.log('before concat', this.newsData);
                this.newsData = allData.concat(this.newsData);
                // console.log('after concat', this.newsData);
            }
        }
        else
        {
						this.newsData = allData;
				}
        this.top_tip_id = false;// 删除顶部刷新提示
        this.$nextTick(() => {
            this.delOverLenNewsHtml(this.maxNewsLength);// 删除多余显示
            // this.showWatchedTip();// 增加“已经阅读到这里”
            // this.setNewsData('firstNewsId', 'id_' + this.newsData[0].uniquekey);
            this.loadOkNotice();    //发送加载完成
        });
        apdType !== 'end' && (allData = allData.reverse());
        this.saveNewsData(allData, append, apdType);// 缓存至本地
        this.saveNewsInfo(allData, append, apdType);// 更新新闻信息
    },
    showPushNums (data) {// 显示推荐多少条,并根据条件清空新闻列表
        if(!sessionStorage[this.nowNewsType]){ // 如果是第一次切换标签（即还没有本地存储的时候）， 则不做处理
          return ;
        }
        var nums = data.length;// 减去新增广告的条数
        if(nums <= this.flushMaxNums){// 懒加载刷新时不显示加载条数，根据滚动条位置判断
            if(this.getNewsScrollTop() === 0) {
              this.pushNums = nums;
              this.numTipTimeout && clearTimeout(this.numTipTimeout);
              this.numTipTimeout = setTimeout(() => {this.pushNums = false}, this.showNumsTipTime);
            }
        } else {
            this.clearHtml();// 清空所有元素
        // newsCenter.model.setNewsData(newsType, JSON.stringify(data));
        }
    },
    delOverLenNewsHtml (len) { // 删除页面中超过限制条数的多余新闻
        // 删除多余条数
        if($('.news').length >= len){
          $('.news').each(function (ind, el) {
              ind >= len && el.remove();
          });
        }
    },
    checkFlushTime () {
        var lastFlushTime = this.getNewsData('lastFlushTime_' + this.nowNewsType);

        return Date.parse(new Date()) - lastFlushTime > this.flushInterval;
    },
    saveNewsData(allData, append, apdType) {// 保存数据
        var nowPage = df.postData.page;
        var nowIdx = df.postData.idx;
        $.each(allData, function(ind, item){
          allData[ind]['page'] = nowPage;
          allData[ind]['idx'] = nowIdx >= 0 ? nowIdx + ind: nowIdx - ind;
        });
        var newsData;
        if(append) {
          newsData = apdType === 'end' ?
              JSON.stringify(JSON.parse(this.getNewsData(this.nowNewsType)).concat(allData)) :
              JSON.stringify(allData.concat(JSON.parse(this.getNewsData(this.nowNewsType))));
        } else {
          newsData = JSON.stringify(allData);
        }
        this.setNewsData(this.nowNewsType, newsData);// 保存对应数据
    },
    saveNewsInfo (allData, append, apdType) {// 更新新闻信息
        this.setInfo(this.nowNewsType, 'endkey', allData.endkey);// 保存endkey
        this.setInfo(this.nowNewsType, 'newkey', allData.newkey);// 保存newkey

        var newsLength = allData.length;
        //newsCenter.newNewsNums = newsLength;// 更新上拉下拉页码
        apdType === 'end' ?  this.setInfo(this.nowNewsType, 'idx_down', newsLength) : this.setInfo(this.nowNewsType, 'idx_up', newsLength);// 更新上拉下拉idx位置
    },
    getNewsScrollTop () {
        return $('.news-list').scrollTop();
    },
    lazyLoadNews (){
        //console.log('lazy load', this.nowNewsType);

        var postData = {
            type: this.nowNewsType,
            startkey: this.getInfo(this.nowNewsType, 'endkey'),
            newkey: this.getInfo(this.nowNewsType, 'newkey'),
            page: this.pageInfo[this.nowNewsType],
            idx: this.getInfo(this.nowNewsType, 'idx_down'),
            uid: this.getNewsData('uuid'),
        };
        if($('.news').length >= this.maxNewsLength){
            this.createFootTipHtml(this.nowNewsType);
        } else {
            if(!this.onlineOk()){// 断网下什么都不做处理
                return ;
            }

            this.lastUrlParam = this.deepCopy(df.postData);
            this.setAndShowData(postData, true, 'end');
        }
    },
    setNewsScrollTop (scrollTop) {  //设置滚动条位置
        $('.news-list').scrollTop(scrollTop);
    },
    setHeight () {  //设置页面高度
        var win_h = $(window).height(),
        nav_h = $('.news-header').height();
        $('.news-list').height(win_h - nav_h);
    },
    clearErrorHtml() {// 隐藏错误页
        $('.mask').hide();
        $('.no-data').hide();
        $('.J_step01').hide();
        $('.J_step02').hide();
    },
    showClickManualRefresh () {// 显示点击手动刷新按钮
        $('.mask').show();
        $('.no-data').show();
        $('.J_step01').hide();
        $('.J_step02').show();
    },
		countTo2345 (vUrl) {// 2345点击统计，newsType新闻类型 newsInfo新闻信息
				var uaInfo    = navigator.appVersion.substr(-24);
        var version   = uaInfo.substr(0,12) === '2345Explorer' ? uaInfo.substr(uaInfo.indexOf('/')+1) : '';
        var otherInfo = vUrl.substr(0,12) !== 'ttxw_adclick' ? '|version='+version : '';
        var url = 'http://web.50bangzh.com/web/ajax87?uId2=SPTNPQRLSX&r='+encodeURIComponent(document.location.href)+'&fBL='+screen.width+'*'+screen.height+'&lO='+encodeURIComponent(vUrl)+otherInfo;
        var _dh = document.createElement("script");
        _dh.setAttribute("type", "text/javascript");
        _dh.setAttribute("src", url);
        document.getElementsByTagName("head")[0].appendChild(_dh);
    },
    countToDFTT (newsId) {// 传给东方头条的统计
        var allTypeData = JSON.parse(this.getNewsData(this.nowNewsType));
        var newsData;
        $.each(allTypeData, function (ind, item) {
            if(item.uniquekey === newsId){
                newsData = item;
                return;
            }
        });

        var dfttParam;
        if(newsData){
            dfttParam = {
                type  : this.nowNewsType,
                page :  this.pageInfo[this.nowNewsType],
                idx   : newsData.idx,
                uid   : this.getNewsData('uuid'),
                qid   : '2345jsllq',
                ishot : newsData.hotnews,
                url :  newsData.url,
                recommendtype : newsData.recommendtype
            };
        }
        if(dfttParam){
          df.sendToDftt(dfttParam, (err, list) => {

          });
        }
    },
    clickToChangeTab(){     //点击切换标签时触发
        this.showClickManualRefresh();
        this.updateNewsType();  //更新当前选中的标签
        var _scrollTop = this.getNewsData("scrollTop_" + this.nowNewsType) || 0;
        this.newsData = [];
        if (!this.onlineOk())
        {
          this.dealWithOffline(_scrollTop);
        }
        else
        {
          this.dealWithOnline(_scrollTop);
        }
    },
    dealWithOffline (_scrollTop){   //断网情况下的处理逻辑
        var newsType = this.nowNewsType;
        //console.log(newsType);
        // 有记录则直接展示，没有记录则加载数据并展示
        var oldData = this.getNewsData(newsType);
        if (oldData)
        {
            this.newsData = JSON.parse(oldData);
            //console.log(this.newsData);
            this.showTopTip(newsType);
            this.showFootTip(newsType);
            this.setNewsScrollTop(_scrollTop);
        }
        this.checkHaveData();
    },
    dealWithOnline (_scrollTop){      //有网时的处理逻辑
        var newsType = this.nowNewsType;
        //console.log('online:', newsType);
        var oldData = this.getNewsData(newsType);
        if(oldData && oldData !== '[]'){
            // 大于30分钟则刷新当前数据 TODO 解析更新数据时间 newsCenter.tabActiveTime
            var diffMin = new Date().getTime() - this.tabActiveTime[newsType];
            //newsType + '相差差多长时间更新：', diffMin);
            if(diffMin > this.tabUpdateDataTime) {
                //'差毫秒：', diffMin);
                this.setLastloadData(Date.parse(new Date()));
                var postData = {
                    type : this.nowNewsType,
                    startkey : '',
                    newkey : '',
                    page : this.pageInfo[this.nowNewsType],
                    idx : 0,
                    uid : this.getNewsData('uuid')
                };
                this.lastUrlParam = this.deepCopy(df.postData);
                this.setAndShowData(postData, false, 'end');
            } else {
                this.clearErrorHtml();
                this.newsData = JSON.parse(oldData);
            }

        } else {
            this.setLastloadData(Date.parse(new Date()));
            var postData = {
                type : this.nowNewsType,
                startkey : '',
                newkey : '',
                page : this.pageInfo[this.nowNewsType],
                idx : 0,
                uid : this.getNewsData('uuid')
            };
            this.lastUrlParam = this.deepCopy(df.postData);
            this.setAndShowData(postData, false, 'end');
        }
        this.$nextTick(() => {
            this.monitorTopTip();
            this.showTopTip(newsType);
            // this.showWatchedTip();
            this.showFootTip(newsType);
            this.delOverLenNewsHtml(this.maxNewsLength);
            this.delOverLenNewsCache(newsType, this.maxNewsLength);

            this.countTo2345('ttxw_tab_' + newsType + '_tabclick');

            this.setNewsScrollTop(_scrollTop);
        });
    },
    setLastloadData (data) {// 更新标签刷新时间
        this.setNewsData('lastFlushTime_' + this.nowNewsType, data);
    },
    delOverLenNewsCache (newsType, len) {// 删除缓存中超过限制条数的多余新闻
        var allData = JSON.parse(this.getNewsData(newsType));
        if(allData && allData.length > len){
          this.setNewsData(newsType, JSON.stringify(allData.slice(0, len)));
        }
    },
    reloadNews (){// 手动点击“重新加载”，全量加载数据，相当于重新开始
        //console.log('reloadNews');
        this.lastUrlParam.page = 1;
        this.remoteServerOk = true;
        this.showClickManualRefresh();
        if ($('.news').length > 0) {
          this.clearErrorHtml();
        } else {
          this.initTypeData();
          this.checkHaveData();
        }
    },
    refreshNews () {// 根据类型(newsType)进行刷新（刷新按钮、点击查看、查看更多）
        //console.log('refreshNews', this.nowNewsType);
        if (!this.onlineOk()) {
          return ;
        }

        if (!this.remoteServerOk) {// 如果是服务器异常状态
          this.reloadNews();
          return ;
        }

        var loadType = 'begin';
        var postData = {};
        this.setNewsScrollTop(0);         // 跳至顶部
        this.monitorTopTip();     // 顶部监控刷新
        this.delTopTipHtml();// 删除已有顶部提示
        this.delFootTipHtml();// 删除底部提示
        if(this.checkFlushTime()){
          this.setLastloadData(Date.parse(new Date()));
          this.flushNews();
          postData = {
              type : this.nowNewsType,
              startkey : '',
              newkey : '',
              page : this.pageInfo[this.nowNewsType],
              idx : 0,
              uid : this.getNewsData('uuid')
          };
          if(!this.onlineOk()){// 断网下什么都不做处理
              return ;
          }
          this.lastUrlParam = this.deepCopy(df.postData);
          loadType = 'end';
          this.view.clearHtml();
          this.checkHaveData();
        } else {
            postData = {
                type : this.nowNewsType,
                startkey : this.getInfo(this.nowNewsType, 'endkey'),
                newkey : this.getInfo(this.nowNewsType, 'newkey'),
                page : this.pageInfo[this.nowNewsType],
                idx : this.getInfo(this.nowNewsType, 'idx_up'),
                uid : this.getNewsData('uuid')
            };
            if(!this.onlineOk()){// 断网下什么都不做处理
                return ;
            }
            this.lastUrlParam = this.deepCopy(df.postData);
        }
        //console.log('first row id', this.getFirstNewsRowId());
        this.setInfo(this.nowNewsType, 'watched_loc', this.getFirstNewsRowId());
        this.setAndShowData(postData, true, loadType);// 加载最新新闻
    },
    flushNews () {// 重载新闻（强刷当前新闻）
        this.setNewsData(this.nowNewsType, '[]');
        this.setNewsData(this.nowNewsType + '_info', '{}');
    },
    getFirstNewsRowId () {
        //console.log(this.newsData);
        return this.newsData ? 'id_' + this.newsData[0]['uniquekey'] : '';
    },
  }
}
</script>
